import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAircanadaComponent } from './simple-icons-aircanada.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAircanadaComponent ],
    exports:      [ SimpleIconsAircanadaComponent ],
    bootstrap:    []
})
export class SimpleIconsAircanadaModule {}
